namespace GeniuzPOS.QRreport {
    export interface QMonthRow {
        Id?: number;
        Month?: number;
        MonthName?: string;
        MonthNameEn?: string;
        FullName?: string;
        Months?: string;
    }

    export namespace QMonthRow {
        export const idProperty = 'Months';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'QRreport.QMonth';
        export const lookupKey = 'QRreport.QMonth';

        export function getLookup(): Q.Lookup<QMonthRow> {
            return Q.getLookup<QMonthRow>('QRreport.QMonth');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Month = "Month",
            MonthName = "MonthName",
            MonthNameEn = "MonthNameEn",
            FullName = "FullName",
            Months = "Months"
        }
    }
}
